export default __webpack_public_path__ + "img/binla_education.d57e6346.png";